"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Checkbox = ({ checked, indeterminate = false, className = '', style = {}, disabled = false, onChange }) => {
    return (React.createElement("input", { type: "checkbox", className: className, style: style, ref: input => {
            /* istanbul ignore else */
            if (input) {
                input.checked = checked;
                input.indeterminate = indeterminate;
                input.disabled = disabled;
            }
        }, onChange: e => {
            /* istanbul ignore else */
            if (onChange) {
                onChange(e);
            }
        } }));
};
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map